module.exports = __webpack_public_path__ + "img/Service5.7b30b718.svg";